import { createTypedHooks } from 'easy-peasy';

import type { StoreModel } from './model';

const typedHooks = createTypedHooks<StoreModel>();

export const useStore = typedHooks.useStore;
export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
